import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";
import { AuthenticationSelectors } from "../../../auth/state/authentication.selectors";
import { User } from "../../../core/model/user.model";
import { GetsFeatureBaseService } from "../gets-feature-base.service";

@Injectable()
export class GetFeatureFromStateService implements GetsFeatureBaseService {
  constructor(private authenticationSelectors: AuthenticationSelectors) {}

  getAll(): Observable<Set<string>> {
    const permissionKeySet = this.authenticationSelectors
      .selectCurrentUser()
      .pipe(
        map(
          (currentUser: User) =>{
            if(currentUser){
             return   new Set(currentUser.userPermissionKeys as string[])
            }
            return  new Set('');
          }

        )
      );

    return permissionKeySet;
  }
}
